module.exports = __webpack_public_path__ + "img/def-mem.37c3ea6b.png";